






































import DataColor from './DataColor.vue';
import DataOutput from './DataOutput.vue';
import TextHeader from './TextHeader.vue';
import Vue, {PropType} from 'vue';
import {Video} from '@/emulator/EmulatorInfo';

export default Vue.extend({
    name: 'device-video',
    components: { DataColor, DataOutput, TextHeader },
    props: {
        video: { type: Object as PropType<Video>, required: true },
    },
});
